
import React, { useState } from 'react'
import classes from './Album.module.css';
import { useHistory } from "react-router";

const Album = props => {
    const history = useHistory();
    const [description, setShowDescription] = useState(false);

    const handleClick =  () => {
        const loc = `/gallery?description=${props.title}&source=${btoa(props.source)}`;
        console.log('navigating to', loc);
        history.push(loc);
    }

    const showDescription = () =>{
        setShowDescription(!description)
    }

    // const imgSrc = `images/adventures/${props.thumb}`;
    // NEW: prefer backend-provided URL, fall back to old behavior
    if(props.thumbUrl){
        console.log('using thumbUrl:', props.thumbUrl);
    }
    const imgSrc = props.thumbUrl || `images/adventures/${props.thumb}`;

    return (
        <div className={classes.Album} onClick={handleClick.bind(this)}>
            <img onMouseEnter={showDescription.bind(this)} onMouseLeave={showDescription.bind(this)} src={imgSrc} title={props.title} />
            <span className={ !description ? classes.hide : classes.show}>{props.title}</span>
        </div>

    )
}


export default Album
